<template>
  <section><v-container class="fill-height" fluid></v-container></section>
</template>

<script>
export default {
  name: "GoogleOAuthHandling",
  methods: {
    async storeJWT() {
      if (this.$route.query.token) {
        await sessionStorage.setItem("token", this.$route.query.token);
      }
      await this.$router.push({ name: "login" });
    },
  },
  mounted() {
    this.storeJWT();
  },
};
</script>